<template>

    <div>
        <div class="card">
            <div class="card-body p-lg-5">
                <form @submit.prevent="submit_search" class="">
                    <div class="row">
                        <div class="col-md-6">
                            <select v-model="search_form.category_id" class="form-control form-control-xl">
                                <option v-for="(category, c_index) in select_mediacategories" :key="c_index" :value="category.id">{{ category.text }}</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <div class="form-media-search-button-group input-group is-invalid">
                                <input type="text" v-model="search_form.search" class="form-control form-control-xl" :placeholder="__('redeem.freetext_search')">
                                <div class="input-group-append">
                                    <button class="btn btn-primary btn-lg" type="submit" :disabled="busy_loading">{{ __('redeem.search') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="busy_loading" class="text-center" style="padding: 40px 0;">
            <div class="spinner-border" role="status"></div>
            <div>{{ __('redeem.loading') }}...</div>
        </div>
        <div v-else-if="search_result.data && search_result.data.length>0">
            <div class="row pt-4 pb-3">
                <div class="col-8"><h2>{{ __('redeem.search_results') }}</h2></div>
                <div v-if="search_result.meta" class="col-4 text-right text-secondary" style="line-height:34px;">{{ search_result.meta.total }} {{ __('redeem.products') }}</div>
                <div v-else class="col-4 text-right text-secondary" style="line-height:34px;">{{ search_result.data.length }} {{ __('redeem.products') }}</div>
            </div>
            <div class="row">
                <div v-for="(product, p_index) in search_result.data" :key="p_index" class="col-xxl-2 col-md-3 col-sm-6 col-6 mb-5">
                    <product-box :product="product" :prod_id="prod_id" :order="order" :type="product.type" :cart_item_id="cart_item_id" media-select></product-box>
                </div>
            </div>
            <div v-if="search_result.meta" class="row">
                <div class="col-12">
                    <p class="text-center text-secondary py-4 mb-0">{{ __('redeem.showing') }} {{ search_result.meta.from }} - {{ search_result.meta.to }} {{ __('redeem.of') }} {{ search_result.meta.total }} {{ __('redeem.products') }}</p>
                    <nav class="rdm-pagination" aria-label="pagination">
                        <ul class="pagination rdm-pagination">
                            <li class="page-item" v-bind:class="{disabled:search_page<=1}">
                                <a class="page-link" @click.prevent="btn_search_go_to_page(search_page-1)" href="#"><i class="fas fa-chevron-left"></i><span class="sr-only">{{ __('redeem.previous_page') }}</span></a>
                            </li>
                            <li class="page-item" v-if="search_page>2">
                                <a class="page-link" @click.prevent="btn_search_go_to_page(search_page-2)" href="#">{{ search_page-2 }}</a>
                            </li>
                            <li class="page-item" v-if="search_page>1">
                                <a class="page-link" @click.prevent="btn_search_go_to_page(search_page-1)" href="#">{{ search_page-1 }}</a>
                            </li>
                            <li class="page-item active">
                                <span class="page-link">{{ search_page }}</span>
                            </li>
                            <li class="page-item" v-if="search_page+1<search_result.meta.last_page">
                                <a class="page-link" @click.prevent="btn_search_go_to_page(search_page+1)" href="#">{{ search_page+1 }}</a>
                            </li>
                            <li class="page-item" v-if="search_page+2<search_result.meta.last_page">
                                <a class="page-link" @click.prevent="btn_search_go_to_page(search_page+2)" href="#">{{ search_page+2 }}</a>
                            </li>
                            <li class="page-item" v-bind:class="{disabled:search_page>=search_result.meta.last_page}">
                                <a class="page-link" @click.prevent="btn_search_go_to_page(search_page+1)" href="#"><i class="fas fa-chevron-right"></i><span class="sr-only">{{ __('redeem.next_page') }}</span></a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
        <div v-else style="display: none; padding: 40px 0;" class="text-center">
            <div class="text-center">{{ __('redeem.no_products_found') }}</div>
        </div>
    </div>

</template>

<script>
import Vue from 'vue';

export default {
    props: {
        prod_id: {
            type: Number,
            default: 0,
        },
        cart_item_id: {
            type: String,
            default: null,
        },
        order: {
            type: Boolean,
            default: false,
        },
        media_categories: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data: () => ({
        busy_loading: true,
        search_form: {
            prod_id: 0,
            search: '',
            category_id: 0,
        },
        search_page: 1,
        search_result: {},
    }),
    mounted() {
        Vue.set(this.search_form, 'prod_id', this.prod_id);
        // const hasParams = this.get_urlParams();
        // if(hasParams){
        this.do_search();
        // }
    },
    created() {
        const vm = this;
        window.onpopstate = (event) => {
            Object.keys(event.state).forEach((index) => {
                if (vm.search_form[index] !== undefined) {
                    vm.search_form[index] = event.state[index];
                } else if (index === 'page') {
                    vm.search_page = parseInt(event.state[index], 10);
                }
            });
            vm.do_search();
        };
    },
    methods: {
        get_urlParams() {
            const vm = this;
            let hasParams = false;
            // eslint-disable-next-line no-unused-vars
            const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
                if (vm.search_form[key] !== undefined) {
                    vm.search_form[key] = decodeURIComponent(value);
                    hasParams = true;
                } else if (key === 'page') {
                    vm.search_page = parseInt(value, 10);
                    hasParams = true;
                }
            });
            return hasParams;
        },
        set_search_history() {
            const urlParams = Object.keys(this.search_form).map((key) => `${key}=${encodeURIComponent(this.search_form[key])}`).join('&');
            const formData = JSON.parse(JSON.stringify(this.search_form));
            formData.page = this.search_page;
            // eslint-disable-next-line no-restricted-globals
            history.pushState(formData, 'title 1', '?' + urlParams + '&page=' + this.search_page);
        },
        submit_search() {
            this.search_page = 1;
            this.set_search_history();
            this.do_search();
        },
        btn_search_go_to_page(page) {
            this.search_page = page;
            this.set_search_history();
            this.do_search();
            const elmnt = document.getElementById('header');
            document.documentElement.scrollTop = elmnt.offsetHeight;
        },
        do_search() {
            const self = this;
            this.busy_loading = true;

            const searchParams = {
                page: this.search_page,
                ...this.search_form,
            };

            axios.get('/vue/' + this.__('redeem.current_langcode') + '/get_media', { params: searchParams })
                .then((response) => {
                    Vue.set(self, 'search_result', response.data);
                })
                .finally(() => {
                    Vue.set(self, 'busy_loading', false);
                });
        },
    },
    computed: {
        select_mediacategories() {
            const arr = this.media_categories;
            arr.unshift({ id: 0, text: this.__('redeem.all_categories') });
            return arr;
        },
    },
};
</script>
